import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../../content/utils.js';
import { RATINGS } from '../../../../lib/schema.js';
import { navigateToProjectReports } from '../../../links/index.jsx';
import RatingLabel from '../../../RatingLabel.jsx';

const SCOPES = RATINGS.LARGE_MEDIUM_SMALL;

ScopeFilter.propTypes = {
  selectedScopes: PropTypes.arrayOf(PropTypes.oneOf(SCOPES)),
};

ScopeFilter.defaultProps = {
  selectedScopes: [],
};

function ScopeFilter({ selectedScopes }) {
  const selectedCount = selectedScopes.length;

  const handleSelect = useCallback(
    (scope) =>
      navigateToProjectReports({
        scope: scope ? xor(selectedScopes, [scope]) : [],
      }),
    [selectedScopes]
  );

  const renderMenuItem = useCallback(
    (scope) => (
      <React.Fragment key={scope}>
        <MenuItem
          active={selectedScopes.includes(scope)}
          eventKey={scope}
          onSelect={handleSelect}
        >
          <RatingLabel rating={scope} reverse />
        </MenuItem>
      </React.Fragment>
    ),
    [selectedScopes]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        {getOrgTermsContent('projectScope')}
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="scope-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {SCOPES.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default ScopeFilter;
